import React, { useRef, useEffect, useState } from 'react';
import axios from 'axios';
import ReactPlayer from 'react-player';
import { Swiper, SwiperSlide } from 'swiper/react';

import Webcam from 'react-webcam';
import jsQR from 'jsqr';

import 'swiper/css';
import './MainPage.css';

import logoImage from './../../image/logo.svg';
import userIcon from './../../image/user-icon.svg';
import mainImage from './../../image/image-3.jpg';

import offButton from './../../image/off-btn.svg';
import activeButton from './../../image/active-btn.svg';

import videoDemo from './../../video/video.MP4';

const MainPage = ({
    setCurrentPage,
    firstUserName,
    lastUserName,
    isButtonActive,
    setIsButtonActive,
    setIsShowSuccess,
    setIsShowError,
    setSuccessStatus,
    setErrorStatus,
    isUserHavePlace,
    setIsUserHavePlace,
    tableId,
    setTableId,
    setIsShowNavigation,
    setIsShowProductCard,
    loadingUserCallTime,
    userCallTime,
    setIsShowPopUpModal,
    setSelectProduct,
    setCartItems,
    setTotalSum,
    setProductCount,
}) => {
    const [mainSrcData, setMainSrcData] = useState([]);
    const [isShowButton, setIsShowButton] = useState(false);

    const [showScanner, setShowScanner] = useState(false);
    const [scanResult, setScanResult] = useState(null);

    const [isBarmenDisabled, setIsBarmenDisabled] = useState(false);
    const [barmenProgress, setBarmenProgress] = useState(0); // прогресс для бармена
    const [isKmDisabled, setIsKmDisabled] = useState(false);
    const [kmProgress, setKmProgress] = useState(0); // прогресс для кальянного мастера
    const [isInvoiceDisabled, setIsInvoiceDisabled] = useState(false);
    const [invoiceProgress, setInvoiceProgress] = useState(0); // прогресс для счета

    const webcamRef = useRef(null);

    useEffect(() => {
        console.log('isBarmenDisabled', isBarmenDisabled);
        console.log('isKmDisabled', isKmDisabled);
        console.log('isInvoiceDisabled', isInvoiceDisabled);
        console.log('mainSrcData', mainSrcData);
    }, [isBarmenDisabled, isKmDisabled, isInvoiceDisabled, mainSrcData]);

    // вызов персонала
    useEffect(() => {
        if (userCallTime) {
            const now = new Date();
            const timeZoneOffset = now.getTimezoneOffset() * 60000;

            const updateProgress = (
                lastCallTime,
                setProgress,
                setIsDisabled
            ) => {
                if (lastCallTime) {
                    const lastCall = new Date(lastCallTime);
                    const localCallTime = new Date(
                        lastCall.getTime() - timeZoneOffset
                    );
                    const diff = now - localCallTime;
                    const remainingTime = 7 * 60 * 1000 - diff;

                    if (remainingTime > 0) {
                        setIsDisabled(true);
                        const progress =
                            ((7 * 60 * 1000 - remainingTime) /
                                (7 * 60 * 1000)) *
                            100;
                        setProgress(progress);

                        const interval = setInterval(() => {
                            setProgress((prevProgress) => {
                                const newProgress =
                                    prevProgress + 100 / (7 * 60);
                                if (newProgress >= 100) {
                                    clearInterval(interval);
                                    setIsDisabled(false);
                                    return 100;
                                }
                                return newProgress;
                            });
                        }, 1000);

                        return () => clearInterval(interval);
                    } else {
                        setIsDisabled(false);
                        setProgress(100);
                    }
                }
            };

            updateProgress(
                userCallTime.lastBarmenCallTime,
                setBarmenProgress,
                setIsBarmenDisabled
            );
            updateProgress(
                userCallTime.lastKmCallTime,
                setKmProgress,
                setIsKmDisabled
            );
            updateProgress(
                userCallTime.lastInvoiceCallTime,
                setInvoiceProgress,
                setIsInvoiceDisabled
            );
        }
    }, [userCallTime]);

    // видео для главной страницы
    useEffect(() => {
        const loadingDataToMain = async () => {
            try {
                const response = await axios.get(
                    'https://apihpwild.ru/main/menu',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                    }
                );
                if (response.data.success) {
                    setMainSrcData(response.data.result);
                }
            } catch (error) {
                console.error('Ошибка загрузки данных ', error);
            }
        };
        loadingDataToMain();
    }, []);

    useEffect(() => {
        if (isUserHavePlace === true) {
            setIsShowButton(true);
        }
    }, [isUserHavePlace]);

    useEffect(() => {
        if (showScanner) {
            const interval = setInterval(handleScan, 300);
            return () => clearInterval(interval);
        }
    }, [showScanner]);

    useEffect(() => {
        const handleQRCodeSend = async () => {
            const scanResultId = scanResult.split('=table')[1];

            try {
                const response = await axios.get(
                    'https://apihpwild.ru/rest/user/placing',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            tableId: scanResultId,
                        },
                    }
                );
                if (response.data.success) {
                    setIsUserHavePlace(true);
                    setTableId(scanResultId);

                    const keys = Object.keys(localStorage);

                    keys.forEach((key) => {
                        if (key.startsWith('product_')) {
                            localStorage.removeItem(key);
                        }
                    });

                    setCartItems([]);
                    setTotalSum(0);
                    setProductCount({});
                    localStorage.setItem('totalSum', 0);

                    console.log('Стол занят пользователем');
                }
            } catch (error) {
                console.error('Не удалось отправить ссылку на сервер ', error);
            }
        };

        if (scanResult) {
            handleQRCodeSend();
        }
    }, [scanResult]);

    const handleScan = () => {
        const canvas = webcamRef.current.getCanvas();
        if (canvas) {
            const imageData = canvas
                .getContext('2d')
                .getImageData(0, 0, canvas.width, canvas.height);
            const code = jsQR(
                imageData.data,
                imageData.width,
                imageData.height
            );
            if (code) {
                setScanResult(code.data);
                setShowScanner(false);
            }
        }
    };

    const handleQrCodeClick = () => {
        setShowScanner(true);
    };

    const handleBookingClick = () => {
        setCurrentPage('BookingPage');
    };

    const handleButtonClick = () => {
        setIsButtonActive(!isButtonActive);
    };

    const handleMenuClick = () => {
        setIsShowNavigation(true);
        setIsShowProductCard(false);
        setCurrentPage('MenuPage');
    };

    // вызов персонала
    const handlePersonalClick = async (typeCall) => {
        if (
            (typeCall === 'Barmen' && isBarmenDisabled) ||
            (typeCall === 'Km' && isKmDisabled) ||
            (typeCall === 'Invoice' && isInvoiceDisabled)
        ) {
            setIsShowPopUpModal(true);
            return;
        }

        try {
            const response = await axios.post(
                'https://apihpwild.ru/rest/call/personal',
                {
                    typeCall: typeCall,
                    id: tableId,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );

            if (response.data.success) {
                setSuccessStatus(2);
                setIsShowSuccess(true);
                loadingUserCallTime();
            }
        } catch (error) {
            console.error('Ошибка при вызове персонала ', error);
            if (error.response.data) {
                setErrorStatus(3);
                setIsShowError(true);
            }
        }
    };

    const handleProductClick = async (id) => {
        try {
            const response = await axios.get(
                'https://apihpwild.ru/main/product',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        productId: id,
                    },
                }
            );
            if (response.data.success) {
                setSelectProduct(response.data.result);
                setIsShowProductCard(true);
            }
        } catch (error) {
            console.error('Ошибка получения данных о блюде: ', error);
        }
    };

    return (
        <div className='main__wrapper'>
            <div className='main__container'>
                <div className='main__logo'>
                    <img src={logoImage} alt='Logo' />
                </div>
                <div className='main__user_items'>
                    <img src={userIcon} />
                    <h3 className='main__user_info'>
                        {`${firstUserName} ${lastUserName}`}
                    </h3>
                </div>
                <div className='main__group_items'>
                    <div className='main__btns'>
                        <button
                            className='main__btn'
                            onClick={handleBookingClick}
                        >
                            Бронирование
                        </button>
                        <button
                            className='main__btn'
                            onClick={handleQrCodeClick}
                        >
                            Сканировать QR-код
                        </button>

                        {isShowButton && (
                            <button
                                className='main__btn'
                                onClick={handleMenuClick}
                            >
                                Меню
                            </button>
                        )}

                        {isShowButton && (
                            <button
                                className={`${
                                    isButtonActive
                                        ? 'main__btn_active'
                                        : 'main__btn'
                                }`}
                                onClick={handleButtonClick}
                            >
                                <p>Вызов персонала</p>
                                <img
                                    className='main__btn_icon'
                                    src={
                                        isButtonActive
                                            ? activeButton
                                            : offButton
                                    }
                                />
                            </button>
                        )}
                        {isButtonActive && (
                            <button
                                className={`main__btn_add ${
                                    isBarmenDisabled ? 'disabled' : ''
                                }`}
                                onClick={() => handlePersonalClick('Barmen')}
                                style={{ '--progress': `${barmenProgress}%` }}
                            >
                                <span>Бармен</span>
                            </button>
                        )}
                        {isButtonActive && (
                            <button
                                className={`main__btn_add ${
                                    isKmDisabled ? 'disabled' : ''
                                }`}
                                onClick={() => handlePersonalClick('Km')}
                                style={{ '--progress': `${kmProgress}%` }}
                            >
                                <span>Кальянный мастер</span>
                            </button>
                        )}
                        {isButtonActive && (
                            <button
                                className={`main__btn_add ${
                                    isInvoiceDisabled ? 'disabled' : ''
                                }`}
                                onClick={() => handlePersonalClick('Invoice')}
                                style={{ '--progress': `${invoiceProgress}%` }}
                            >
                                <span>Счёт</span>
                            </button>
                        )}
                    </div>
                    {!isShowButton && (
                        <div className='main__image'>
                            <img src={mainImage} />
                        </div>
                    )}

                    {isShowButton && mainSrcData.length > 0 && (
                        <div className='main__video'>
                            <Swiper
                                className='mySwiper'
                                centeredSlides={true}
                                loop={true}
                                slidesPerView={1.5}
                                spaceBetween={20}
                            >
                                {mainSrcData.map((srcVideo) => (
                                    <SwiperSlide
                                        key={srcVideo.id}
                                        onClick={() =>
                                            handleProductClick(srcVideo.id)
                                        }
                                    >
                                        <div className='slide-content'>
                                            {srcVideo.video && (
                                                <ReactPlayer
                                                    url={`https://apihpwild.ru${srcVideo.video}`}
                                                    playing={true}
                                                    loop={true}
                                                    muted={true}
                                                    controls={false}
                                                    width='100%'
                                                    height='100%'
                                                    playsinline={true}
                                                />
                                            )}
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    )}
                </div>
                {showScanner && (
                    <div className='qr-scanner'>
                        <Webcam
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat='image/jpeg'
                            videoConstraints={{
                                facingMode: 'environment',
                            }}
                            style={{
                                width: '90%',
                                maxWidth: '600px',
                                borderRadius: '10px',
                            }}
                        />
                        <button onClick={() => setShowScanner(false)}>
                            Закрыть сканер
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default MainPage;
